// extracted by mini-css-extract-plugin
export default {"container":"not-allowed_container__HY0RV","content":"not-allowed_content__2YWar","title":"not-allowed_title__x2dCO"};